import { PathBuilder, routeManager } from '@lib/route-manager';
import { Token } from '@module/user';
import getConfig from 'next/config';

const BRICKS_PATH = '/bricks';

export const getAccessToken = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  return localStorage.getItem('access_token');
};

export const hasValidAccessToken = (): boolean => {
  const accessToken = getAccessToken();
  if (!accessToken) {
    return false;
  }
  return !Token.isTokenExpired(accessToken);
};

/**
 * Public Teacher Portal routes when not logged in: Explore tab and related URLs.
 * `/bricks?menu=explore` is public in route config; `/bricks?menu=[assignmentType]` also matches
 * `explore` as a menu value — we treat only explore (+ optional category browse) as public.
 */
export const isPublicTestMakerBricksPath = (asPath: string): boolean => {
  if (!asPath) {
    return false;
  }

  const [pathname, queryString = ''] = asPath.split('?');
  const searchParams = new URLSearchParams(queryString);
  const menu = (searchParams.get('menu') || '').toLowerCase();

  if (pathname === BRICKS_PATH) {
    return menu === '' || menu === 'explore';
  }

  if (pathname.startsWith(`${BRICKS_PATH}/explore/`)) {
    return true;
  }

  return false;
};

export const isProtectedTestMakerPath = (asPath: string): boolean => {
  if (asPath.split('?')[0].startsWith(`${BRICKS_PATH}/classes/`)) {
    return true;
  }
  if (isPublicTestMakerBricksPath(asPath)) {
    return false;
  }
  return routeManager.standard.testMaker.checkProtectedPath(asPath);
};

export const buildAuthenticationRedirectUrl = (redirectUrl: string): string => {
  const { publicRuntimeConfig } = getConfig();

  return new PathBuilder()
    .withBasePath(routeManager.standard.identity.fullPath.authentication.path)
    .withQueryParam('page', 'sign-in')
    .withQueryParam('clientId', publicRuntimeConfig.clientId)
    .withQueryParam('redirectUrl', redirectUrl)
    .build();
};

export const buildManageSubscriptionUrl = (): string => {
  const { publicRuntimeConfig } = getConfig();
  const identityBaseUrl = publicRuntimeConfig.app?.authentication?.baseUrl as string;

  return new PathBuilder()
    .withBasePath(`${identityBaseUrl}/account-setting/plan`)
    .withQueryParam('clientId', publicRuntimeConfig.clientId ?? 'teacher')
    .build();
};
